var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.963 21a.9.9 0 0 1-.487-.137.96.96 0 0 1-.341-.363A1.1 1.1 0 0 1 2 20.012a.9.9 0 0 1 .134-.512l9.013-16A.988.988 0 0 1 12 3a.99.99 0 0 1 .852.5l9.013 16a.9.9 0 0 1 .134.512 1.1 1.1 0 0 1-.134.488.96.96 0 0 1-.34.363.9.9 0 0 1-.488.137zM12 18a.93.93 0 0 0 .694-.288.98.98 0 0 0 .28-.712.98.98 0 0 0-.28-.712A.93.93 0 0 0 12 16a.93.93 0 0 0-.694.288.98.98 0 0 0-.28.712q0 .424.28.712A.93.93 0 0 0 12 18m0-3a.93.93 0 0 0 .694-.287.98.98 0 0 0 .28-.713v-3a.98.98 0 0 0-.28-.713A.93.93 0 0 0 12 10a.93.93 0 0 0-.694.287.98.98 0 0 0-.28.713v3q0 .424.28.713A.93.93 0 0 0 12 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleFill);
export default __webpack_public_path__ + "static/media/Warning Triangle_fill.b50fae56928e9927673b363965232fb4.svg";
export { ForwardRef as ReactComponent };